import React, {Fragment} from 'react';
import {JsonForms} from '@jsonforms/react';
import {materialCells, materialRenderers} from '@jsonforms/material-renderers';
import RadioControl from '../controls/Radio/RadioControl';
import RadioControlTester from '../controls/Radio/RadioControlTest';
import FileUploadControl from '../controls/FileUpload/FileUploadControl';
import FileUploadControlTester from '../controls/FileUpload/FileUploadTest';
import CheckboxControlTest from "../controls/Checkbox/CheckboxControlTest";
import CheckboxControl from "../controls/Checkbox/CheckboxControl";
import NumberControl from "../controls/Number/NumberControl";
import RatingControl from "../controls/Rating/RatingControl";
import FormulaControl from "../controls/Formula/FormulaControl";
import NumberControlTester from "../controls/Number/NumberControlTest";
import RatingControlTester from "../controls/Rating/RatingControlTest";
import FormulaControlTester from "../controls/Formula/FormulaControlTest";
import DateControl from "../controls/Date/DateControl";
import DateControlTest from "../controls/Date/DateControlTest";
import TimeControl from "../controls/Time/TimeControl";
import TimeControlTest from "../controls/Time/TimeControlTest";
import TextControl from "../controls/Text/TextControl";
import TextControlTest from "../controls/Text/TextControlTest";
import EmailControl from "../controls/Email/EmailControl";
import EmailControlTest from "../controls/Email/EmailControlTest";
import TextAreaControl from "../controls/TextArea/TextAreaControl";
import TextAreaControlTest from "../controls/TextArea/TextAreaControlTest";
import SelectControl from "../controls/Select/SelectControl";
import SelectControlTest from "../controls/Select/SelectControlTest";
import ContentControlTest from "../controls/Content/ContentControlTest";
import ContentControl from "../controls/Content/ContentControl";
import PhoneControlTest from "../controls/Phone/PhoneControlTest";
import PhoneControl from "../controls/Phone/PhoneControl";
import RangeControlTest from "../controls/Range/RangeControlTest";
import RangeControl from "../controls/Range/RangeControl";
import SignatureControlTest from "../controls/Signature/SignatureControlTest";
import SignatureControl from "../controls/Signature/SignatureControl";
import SummaryControl from "../controls/Summary/SummaryControl";
import SummaryControlTest from "../controls/Summary/SummaryControlTest";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import { Container, CircularProgress, useMediaQuery, useTheme } from "@mui/material"
import {LoaderWrapper, Loader, PayProcessStatusText, SocialWrapper, SocialList, SocialListItem, SocialListLink, ButtonGroup} from "../styles/jss/global";
import {TabButton, TabsBox, TabsPositionWrapper} from '../styles/jss/components/tabs';
import {ContentColumn, ContentHeaderTitle, ContentHeaderWrapper} from '../styles/jss/components/content';
import { FormWrapper } from '../styles/jss/components/forms/form-group-elements';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import Button from '../components/Button/Button';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import TabPanel from '../components/Tabs/TabPanel';
import SaveModal from "../components/Modal/SaveModal";
import {PageView} from "../model/enums/PageView";
import {FormPagesState} from '../model/FormPagesState'
import {ValidationUtil} from '../util/ValidationUtil';
import {SignatureUtil} from "../util/SignatureUtil";
import {SubmissionUtils} from "../util/SubmissionUtils";
import {HistoryStateUtils} from "../util/HistoryStateUtils";
import {SchemaUtils} from "../util/SchemaUtils";
import ReCAPTCHA from "react-google-recaptcha";
import AutocompleteControlTest from '../controls/Autocomplete/AutocompleteControlTest';
import AutocompleteControl from '../controls/Autocomplete/AutocompleteControl';
import ColumnsControlTest from "../controls/Columns/ColumnsControlTest";
import ColumnsControl from "../controls/Columns/ColumnsControl";
import {TikTokIcon} from "../constants/tikTokLink";


function FormPages(props: any) {
    const [state, setState] = React.useState(
      new FormPagesState(
        props.state.page,
        props.state.appData,
        props.state.app.name + ' Saved'
      )
    );

    const theme = useTheme()
    const [appValidated, setAppValidated] = React.useState(false);

    let isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        noSsr: true
    });
  
    const reCaptchaRef = React.useRef<any>(null);
  
    const componentProps = {
      showHeader: true,
      showHeaderSocial: false,
      app: {
        name: props.state.app.name,
        logo: props.state.app.logo,
        url: props.state.app.url,
        bgImage: props.state.app.bgImage,
        facebookLink: props.state.app.facebookLink,
        twitterLink: props.state.app.twitterLink,
        linkedinLink: props.state.app.linkedinLink,
        instagramLink: props.state.app.instagramLink,
        tikTokLink: props.state.app.tikTokLink,
        payment: props.state.app.payment,
        config: props.state.app.config,
        version: props.state.app.updatedDate,
        template: props.state.app.template,
      },
      appSchemas: props.state.app.schemas,
      totalPages: props.state.app.schemas.uiSchema.elements.length,
    };
  
    const componentEvents = {
      handleShowSpecificPageWithDataClick: props.handleShowSpecificPageWithDataClick,
      handleSuccessSubmitFormData: props.handleSuccessSubmitFormData,
      handleShowErrorPage: props.handleShowErrorPage,
    };

    const getInvalidPages = (excludeRequired: boolean = false) => {
        let invalidPages = [];

        for (let i = 0; i < componentProps.totalPages; i++) {
            let validationResult = ValidationUtil.validatePage(i, state.appData,
                componentProps.appSchemas.uiSchema, componentProps.appSchemas.dataSchema, excludeRequired);

            if (validationResult.isRequired || !validationResult.isValid) {
                invalidPages.push(i);
            }
        }

        return invalidPages;
    }

    const handleSaveClick = () => {
        setAppValidated(true);
        let invalidPages = getInvalidPages(true);

        if (invalidPages.length) {
            setState((state) => ({
                ...state,
                invalidPages: invalidPages,
                page: invalidPages[0]
            }));
        } else {
            setState((state) => ({
                ...state,
                validatingRequest: true,
                saving: true
            }));

            if (reCaptchaRef.current) {
                reCaptchaRef.current.execute();
            }
        }
    }

    const handleSubmitClick = () => {
        setAppValidated(true);
        let invalidPages = getInvalidPages();

        if (invalidPages.length) {
            SignatureUtil.savePageSignatures(
                state.page,
                state.appData,
                componentProps.appSchemas.uiSchema,
                componentProps.appSchemas.dataSchema);
            setState((state) => ({
                ...state,
                invalidPages: invalidPages,
                page: invalidPages[0]
            }));
        } else {
            setState((state) => ({
                    ...state,
                    loading: true,
                    validatingRequest: true,
                    saving: false
                })
            );
            reCaptchaRef.current.execute();
        }
    }

    const handleNextPageClick = () => {
        let page = state.page;
        let validationResult = ValidationUtil.validatePage(state.page, state.appData,
            componentProps.appSchemas.uiSchema, componentProps.appSchemas.dataSchema);
        if (!validationResult.isValid) {
            const invalidPages = getInvalidPages()
            setState((state) => ({...state, invalidPages: invalidPages, page: invalidPages[0]}));
            return
        }

        SignatureUtil.savePageSignatures(page, state.appData, componentProps.appSchemas.uiSchema,
            componentProps.appSchemas.dataSchema);

        if (page === componentProps.totalPages - 1) {
            setAppValidated(true);
            let invalidPages = getInvalidPages();

            if (invalidPages.length) {
                setState((state) => ({...state, invalidPages: invalidPages, page: invalidPages[0] }));
            } else {
                componentEvents.handleShowSpecificPageWithDataClick(state.appData, page, PageView.Review);
            }
        } else {
            setState((state) => ({...state, page: page + 1, invalidPages: state.invalidPages.length ? getInvalidPages() : []}));
        }
    }

    const handleBackPageClick = () => {
        if (state.page === 0) {
            componentEvents.handleShowSpecificPageWithDataClick(state.appData, state.page, PageView.Welcome);
        } else {
            SignatureUtil.savePageSignatures(state.page, state.appData, componentProps.appSchemas.uiSchema,
                componentProps.appSchemas.dataSchema)
            setState((state) => ({...state, page: state.page - 1}));
        }
    }

    const handleTabChange = (event: React.ChangeEvent<{}>, pageNumber: number) => {
        let validationResult = ValidationUtil.validatePage(state.page, state.appData,
            componentProps.appSchemas.uiSchema, componentProps.appSchemas.dataSchema);
        if (pageNumber < state.page || validationResult.isValid) {
            setState((state) => ({...state,page: pageNumber, invalidPages: state.invalidPages.length ? getInvalidPages() : []}));
        }
    }

    const handleFormDataChange = (appData: any) => {
        const amountToPay = componentProps.app.payment !== undefined ?
            SchemaUtils.getPaymentPrice(
                componentProps.app.payment.config.paymentRules,
                appData,
                componentProps.app.payment.config.price) : "0.00";

        setState((state) => ({
            ...state,
            appData: appData,
            amountToPay: amountToPay
        }));
    }

    const handleValidatingRequest = (started: boolean) => {
        setState((state) => ({
            ...state,
            validatingRequest: started
        }));
    }

    const handleSubmitAppData = (started: boolean) => {
        setState((state) => ({
            ...state,
            submittingAppData: started
        }));
    };

    const handleSavingAppData = (started: boolean) => {
        setState((state) => ({
            ...state,
            savingAppData: started
        }));
    }

    const handleRecaptchaError = () => {
        componentEvents.handleShowErrorPage(
            "The Recaptcha challenge has errored, possibly due to network issues, please refresh the app and start again",
            false,
            null
        );
    }

    const handleRecaptchaExpired = () => {
        componentEvents.handleShowErrorPage(
            "The Recaptcha challenge has expired, please refresh the app and start again",
            false,
            null
        );
    }

    const handleRecaptchaResolved = async (token: any) => {
        if(token === null){
            return;
        }
        handleValidatingRequest(false);

        if(state.saving){
            setState((state) => ({
                ...state,
                saving: false
            }));
            handleSavingAppData(true);
            let response = await SubmissionUtils.saveAppData(componentProps.app, state.appData, token,
                state.page);
            if (response.data.processed) {
                HistoryStateUtils.addSavedStateToUrlPathIfNecessary(response.data.draftSubmissionId);
                let savedStateAppUrl = generateSavedStateAppUrl(response.data.draftSubmissionId);
                setState((state) => ({
                    ...state,
                    savingAppData: false,
                    saveModalOpen: true,
                    savedStateAppUrl: savedStateAppUrl,
                    draftSubmissionId: response.data.draftSubmissionId
                }));
            } else {
                componentEvents.handleShowErrorPage(response.data.message, false, state.appData);
            }
        }else{
            handleSubmitAppData(true);
            let response = await SubmissionUtils.submitAppData(componentProps.app, state.appData,
                token, false, false);
            if (response.data.processed) {
                handleSubmitAppData(false);
                componentEvents.handleSuccessSubmitFormData(state.appData, response.data.uniqueIds,
                    response.data.paymentDetails, false);
            } else {
                componentEvents.handleShowErrorPage(response.data.message, response?.data.app.schemas !== undefined,
                    state.appData, response.data.messageItems, response.data.actionMessage);
            }
        }
    }

    const copyToClipboard = (e: any) => {
        let savedStateAppUrl = generateSavedStateAppUrl(state.draftSubmissionId);
        navigator.clipboard.writeText(savedStateAppUrl);
        setState((state) => ({
            ...state,
            copySuccess: 'Copied'
        }));
    };

    const generateSavedStateAppUrl = (draftSubmissionId: string) => {
        let url = componentProps.app.url;
        return `${url}/${draftSubmissionId}`;
    }

    const copiedToClipboard = (e: any) => {
        setTimeout(() => {
            setState((state) => ({
                ...state,
                copySuccess: 'Copy'
            }));
        }, 500);
    };

    const handleCloseModal = () => {
        setState((state) => ({
            ...state,
            saveEmailAddress: "",
            draftSubmissionId: "",
            saveModalOpen: false,
            saveEmailAddressErrorMessage: "",
            savedStateAppUrl: ""
        }))
    };

    const handleModalSubmit = async(e: any) => {
        e.preventDefault();
        let saveEmailAddressErrorMessage = 'email should not be empty';
        let saveEmailSubjectErrorMessage = 'subject should not be empty';
        const response = await SubmissionUtils.savedAppDataEmail(
            state.saveEmailAddress,
            state.saveEmailSubject,
            state.draftSubmissionId);
        if(response.data.processed){
            handleCloseModal();
            saveEmailAddressErrorMessage = '';
            saveEmailSubjectErrorMessage = '';
        }
        if(saveEmailAddressErrorMessage !== ''){
            setState((state) => ({
                ...state,
                saveEmailAddressErrorMessage: saveEmailAddressErrorMessage,
                saveEmailSubjectErrorMessage: saveEmailSubjectErrorMessage
            }))
        }
    }

    const handleEmailAddressChange = async (event:any) => {
        let text = event.currentTarget.value;
        let saveEmailAddressErrorMessage = '';
        let regexInvalidCharacters = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,7})+$/;


        if (!text.match(regexInvalidCharacters)) {
            saveEmailAddressErrorMessage = 'Please ensure a valid email is entered';
        }

        setState((state) => ({
            ...state,
            saveEmailAddress: text,
            saveEmailAddressErrorMessage: saveEmailAddressErrorMessage
        }));
    };

    const handleEmailSubjectChange = async (event:any) => {
        let text = event.currentTarget.value;
        let saveEmailSubjectErrorMessage = '';
        let regexInvalidCharacters = /^[^#%&*:<>?/{|}]+$/;


        if (!text.match(regexInvalidCharacters)) {
            saveEmailSubjectErrorMessage = 'Please ensure a valid subject is entered';
        }

        setState((state) => ({
            ...state,
            saveEmailSubject: text,
            saveEmailSubjectErrorMessage: saveEmailSubjectErrorMessage
        }));
    };

  
    const page = state.page,
        hideSummaryPage = componentProps.app.config?.hideSummaryPage;
    const withPaymentNotRequired = componentProps.app.payment !== undefined && state.amountToPay !== "0.00"  &&
        !componentProps.app.payment.config.required;
    const withoutPayment = componentProps.app.payment === undefined || state.amountToPay === "0.00";
    const isLastPage = page === componentProps.totalPages - 1;
    const showSubmitButton = isLastPage && hideSummaryPage && withoutPayment;
    const submitButtonText = (showSubmitButton && withPaymentNotRequired) ? "Submit" : "Submit";
    const showSaveButton = componentProps.app.config?.enableSaveForm === true;
    const saveButtonText = "Save";
    const submitButtonVariant = (showSubmitButton && withPaymentNotRequired) ? "outlined" : "contained";
    const saveButtonVariant = "outlined";
    const showNextButton = !showSubmitButton || withPaymentNotRequired
    const nextButtonText = (isLastPage && hideSummaryPage && !withoutPayment) ? "Next" : "Next";

    let a11yProps = (index: any) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`
        };
    };

    const textControlRenderer = React.useCallback((rendererProps: any) => (
        <TextControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const selectControlRenderer = React.useCallback((rendererProps: any) => (
        <SelectControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const emailControlRenderer = React.useCallback((rendererProps: any) => (
        <EmailControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const textAreaControlRenderer = React.useCallback((rendererProps: any) => (
        <TextAreaControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const radioControlRenderer = React.useCallback((rendererProps: any) => (
        <RadioControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const checkboxControlRenderer = React.useCallback((rendererProps: any) => (
        <CheckboxControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const autocompleteControlRenderer = React.useCallback((rendererProps: any) => (
        <AutocompleteControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const numberControlRenderer = React.useCallback((rendererProps: any) => (
        <NumberControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const ratingControlRenderer = React.useCallback((rendererProps: any) => (
        <RatingControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const dateControlRenderer = React.useCallback((rendererProps: any) => (
        <DateControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const timeControlRenderer = React.useCallback((rendererProps: any) => (
        <TimeControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const phoneControlRenderer = React.useCallback((rendererProps: any) => (
        <PhoneControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const signatureControlRenderer = React.useCallback((rendererProps: any) => (
        <SignatureControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const fileUploadControlRenderer = React.useCallback((rendererProps: any) => (
        <FileUploadControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const columnsControlRenderer = React.useCallback((rendererProps: any) => (
        <ColumnsControl {...rendererProps} appValidated={appValidated} />
    ), [appValidated]); // Only recreate when appValidated changes

    const summaryControlRenderer = React.useCallback((rendererProps: any) => (
        <SummaryControl {...rendererProps} appTemplate={componentProps.app.template} />
    ), [componentProps.app.template]);

    return (
        <Fragment>
            <Header {...componentProps} />

            <LoaderWrapper isLoading={state.loading}  component="main" className='main' maxWidth={isDesktop ? "lg" : false}>

                {state.loading &&
                    <Loader>
                        {state.submittingAppData &&
                            <PayProcessStatusText>
                                Your request is being submitted, please wait...
                            </PayProcessStatusText>
                        }
                        {state.savingAppData &&
                            <PayProcessStatusText>
                                Saving, please wait...
                            </PayProcessStatusText>
                        }
                        {state.validatingRequest &&
                            <PayProcessStatusText>
                                Validating request, please wait...
                            </PayProcessStatusText>
                        }
                        <CircularProgress color="primary" size={60} />
                    </Loader>
                }

                <Container classes={{root: 'container-row'}}>
                    <TabsPositionWrapper>
                        <TabsBox
                            value={page}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            orientation={isDesktop ? "vertical" : "horizontal"}
                            aria-label="form tabs"
                            slotProps={{
                                indicator: {
                                    style: isDesktop ? { left: 0 } : {}
                                }
                            }}
                        >
                            {componentProps.appSchemas.uiSchema.elements.map((element: any, index: any) => {
                                let isInvalid = state.invalidPages.includes(index);

                                return (
                                    <TabButton
                                        key={index}
                                        label={<span className="tab-label">{element.label}</span>}
                                        icon={ isInvalid ? <span className="tab-error-icon"><ErrorOutlineIcon fontSize="small" /></span> : ""}
                                        iconPosition='start'
                                        {...a11yProps(index)}
                                    />
                                );
                            })}
                        </TabsBox>
                    </TabsPositionWrapper>

                    <ContentColumn>
                        <ContentHeaderWrapper>
                            <ContentHeaderTitle variant={'h4'}>
                                {componentProps.app.name}
                            </ContentHeaderTitle>
                            <SocialWrapper>
                                <SocialList>
                                    {componentProps.app.facebookLink &&
                                        <SocialListItem>
                                            <SocialListLink href={componentProps.app.facebookLink} target="_blank" rel="noopener noreferrer"><FacebookOutlinedIcon /></SocialListLink>
                                        </SocialListItem>
                                    }
                                    {componentProps.app.twitterLink &&
                                        <SocialListItem>
                                            <SocialListLink href={componentProps.app.twitterLink} target="_blank" rel="noopener noreferrer"><TwitterIcon /></SocialListLink>
                                        </SocialListItem>
                                    }
                                    {componentProps.app.linkedinLink &&
                                        <SocialListItem>
                                            <SocialListLink href={componentProps.app.linkedinLink} target="_blank" rel="noopener noreferrer"><LinkedInIcon /></SocialListLink>
                                        </SocialListItem>
                                    }
                                    {componentProps.app.instagramLink &&
                                        <SocialListItem>
                                            <SocialListLink href={componentProps.app.instagramLink} target="_blank" rel="noopener noreferrer"><InstagramIcon /></SocialListLink>
                                        </SocialListItem>
                                    }
                                    {componentProps.app.tikTokLink &&
                                        <SocialListItem>
                                            <SocialListLink href={componentProps.app.tikTokLink} target="_blank" rel="noopener noreferrer"><TikTokIcon /></SocialListLink>
                                        </SocialListItem>
                                    }
                                </SocialList>
                            </SocialWrapper>
                        </ContentHeaderWrapper>

                        <Container maxWidth="sm" classes={{root: 'container-inner'}}>
                            {componentProps.appSchemas.uiSchema.elements.map((element: any, index: any) => {
                                return (
                                    <TabPanel value={page} index={index} key={index}>
                                        <FormWrapper>
                                            <JsonForms
                                                key={index}
                                                schema={componentProps.appSchemas.dataSchema}
                                                uischema={element}
                                                data={state.appData}
                                                renderers={[
                                                    ...materialRenderers,
                                                    //register custom renderer
                                                    {
                                                        tester: ColumnsControlTest,
                                                        renderer: columnsControlRenderer
                                                    },
                                                    {
                                                        tester: SelectControlTest,
                                                        renderer: selectControlRenderer
                                                    },
                                                    {
                                                        tester: EmailControlTest,
                                                        renderer: emailControlRenderer
                                                    },
                                                    {
                                                        tester: TextControlTest,
                                                        renderer: textControlRenderer
                                                    },
                                                    {
                                                        tester: TextAreaControlTest,
                                                        renderer: textAreaControlRenderer
                                                    },
                                                    {
                                                        tester: RadioControlTester,
                                                        renderer: radioControlRenderer
                                                    },
                                                    {
                                                        tester: CheckboxControlTest,
                                                        renderer: checkboxControlRenderer
                                                    },
                                                    {
                                                        tester: AutocompleteControlTest,
                                                        renderer: autocompleteControlRenderer
                                                    },
                                                    {
                                                        tester: DateControlTest,
                                                        renderer: dateControlRenderer
                                                    },
                                                    {
                                                        tester: TimeControlTest,
                                                        renderer: timeControlRenderer
                                                    },
                                                    {
                                                        tester: NumberControlTester,
                                                        renderer: numberControlRenderer
                                                    },
                                                    {
                                                        tester: RatingControlTester,
                                                        renderer: ratingControlRenderer
                                                    },
                                                    {tester: RangeControlTest, renderer: RangeControl},
                                                    {
                                                        tester: PhoneControlTest,
                                                        renderer: phoneControlRenderer
                                                    },
                                                    {tester: FormulaControlTester, renderer: FormulaControl},
                                                    {
                                                        tester: FileUploadControlTester,
                                                        renderer: fileUploadControlRenderer
                                                    },
                                                    {
                                                        tester: ContentControlTest,
                                                        renderer: ContentControl
                                                    },
                                                    {
                                                        tester: SignatureControlTest,
                                                        renderer: signatureControlRenderer
                                                    },
                                                    {
                                                        tester: SummaryControlTest,
                                                        renderer: summaryControlRenderer
                                                    }
                                                ]}
                                                cells={materialCells}
                                                onChange={({errors, data}) => {
                                                    handleFormDataChange(data);
                                                }
                                            }
                                            />

                                            {state.invalidPages.includes(index) &&
                                                <p className="form-info-message">
                                                    <ErrorOutlineIcon fontSize="small" />
                                                    <span className="form-info-message-text">
                                                        Please fill all required fields and correct any validation messages.
                                                    </span>
                                                </p>
                                            }
                                        </FormWrapper>
                                    </TabPanel>
                                );
                            })}

                            <ButtonGroup className={`button-group-content`}>
                                {((!componentProps.app.config?.hideIntroPage && page >= 0) ||
                                    (componentProps.app.config?.hideIntroPage && page > 0)) &&
                                    <Button
                                    variant="outlined"
                                    size="large"
                                    onClick={handleBackPageClick}
                                    classes={{root: 'button-group-item'}}
                                    >Back</Button>
                                }
                                {showSaveButton &&
                                    <Button
                                        color="secondary"
                                        variant={saveButtonVariant}
                                        size="large"
                                        disableElevation
                                        onClick={handleSaveClick}
                                        classes={{root: 'button-group-item'}}
                                    >{saveButtonText}</Button>
                                }
                                {showSubmitButton &&
                                    <Button
                                        color="secondary"
                                        variant={submitButtonVariant}
                                        size="large"
                                        disableElevation
                                        onClick={handleSubmitClick}
                                        classes={{root: 'button-group-item'}}
                                    >{submitButtonText}</Button>
                                }
                                {page < componentProps.totalPages &&
                                    showNextButton &&
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        size="large"
                                        disableElevation
                                        onClick={handleNextPageClick}
                                        classes={{root: 'button-group-item'}}
                                    >{nextButtonText}</Button>
                                }
                            </ButtonGroup>
                            <ReCAPTCHA
                                ref={reCaptchaRef}
                                size="invisible"
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY!}
                                onChange={handleRecaptchaResolved}
                                onErrored={handleRecaptchaError}
                                onExpired={handleRecaptchaExpired}
                            />
                        </Container>
                    </ContentColumn>
                </Container>
            </LoaderWrapper>
            <SaveModal show={state.saveModalOpen}
                        saveEmailAddress={state.saveEmailAddress}
                        copiedToClipboard={copiedToClipboard}
                        handleCloseModal={handleCloseModal}
                        copyToClipboard={copyToClipboard}
                        copySuccess={state.copySuccess}
                        handleEmailAddressChange={handleEmailAddressChange}
                        handleModalSubmit={handleModalSubmit}
                        savedStateAppUrl={state.savedStateAppUrl}
                        saveEmailAddressErrorMessage={state.saveEmailAddressErrorMessage}
                        saveEmailSubject={state.saveEmailSubject}
                        handleEmailSubjectChange={handleEmailSubjectChange}
                        saveEmailSubjectErrorMessage={state.saveEmailSubjectErrorMessage}/>
            <Footer />
        </Fragment>
    );
}

export default FormPages
